import React from 'react'
import PropTypes from 'prop-types'

import { UIText, UIButton, UILayout, UIIcon } from 'bora-material-ui'
import UIElements from '../../../../consts/UIElements'

const SmartIDButton = ({ translate, margin, xs }, { muiTheme }) => (
  <UIButton
    width="100%"
    height="64px"
    border-radius="4px"
    xs={{ width: '100%', ...xs }}
    background={UIElements.BUTTONS_COLOR}
    margin={margin}
  >
    <UILayout column j-flex-center lineHeight="30px" height="100%" style={{ flexBasis: '0' }}>
      <UIText align="left" size="24px">
        <UILayout row center>
          <UIIcon style={{ position: 'absolute' }} fill="white" type="iconSmartId" margin="0 0 0 11px" id="iconDark" />
          <UIText
            align="center"
            width="100%"
            size="18px"
            xs={{ size: '20px' }}
            lineHeight="1"
            letterSpacing="0.8px"
            weight="bold"
            translate={translate}
            textTransform="uppercase"
            font={muiTheme.secondFontFamilyDem}
          />
        </UILayout>
      </UIText>
    </UILayout>
  </UIButton>
)

SmartIDButton.defaultProps = {
  margin: '0px',
}

SmartIDButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
  margin: PropTypes.string,
}

SmartIDButton.contextTypes = {
  muiTheme: PropTypes.object,
}

export default SmartIDButton
